export default "__VITE_ASSET__CjejTpGY__"